import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.3);
	z-index: 13;
	display: flex;
	align-items: center;
	justify-content: center;
	animation: 0.1s ease-out fadeIn forwards;
	will-change: opacity;

	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`;

const Wrapper = styled.div`
	width: auto;
	box-shadow: 0px 4px 40px -20px black;
	overflow: hidden;
	border-radius: 4px;
	max-width: 80vw;
	min-width: 500px;
	animation: 0.1s ease-out slideDown forwards;

	@keyframes slideDown {
		from {
			transform: translateY(-1em);
		}
		to {
			transform: translateY(0em);
		}
	}
`;

const Header = styled.div`
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;

	background-color: rgba(240,240,240,1);
	padding: 0 40px;
	color: rgb(60,60,60);

	font-size: 16px;
	font-weight: bold;
	text-transform: uppercase;
	letter-spacing: 1px;
`;

const Body = styled.div`
	position: relative;
	min-height: 100px;
	background-color: white;
	max-height: calc(100vh - 300px);
	overflow-y: auto;
	padding: 40px;
`;

const Footer = styled.div`
	height: 80px;
	background-color: rgba(240,240,240,1);
	padding: 0 40px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;


export {
	Container,
	Wrapper,
	Header,
	Body,
	Footer,
}
